"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _graphqlTag = _interopRequireDefault(require("graphql-tag"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    query getInspirations(\n      $status: InspirationStatus,\n      $searchTerm: String,\n      $byCurrentUser: Boolean,\n      $featured: Boolean,\n      $sortBy: String,\n      $order: SortOrder,\n      $organisationId: String,\n      $trending: Boolean,\n      $offset: Int,\n      $limit: Int,\n      $isPublic: Boolean\n    ) {\n        getInspirations(\n          status: $status,\n          searchTerm: $searchTerm,\n          byCurrentUser: $byCurrentUser,\n          featured: $featured,\n          sortBy: $sortBy,\n          order: $order,\n          organisationId: $organisationId,\n          trending: $trending,\n          offset: $offset,\n          limit: $limit,\n          isPublic: $isPublic\n        ) {\n            inspirationId\n            title\n            description\n            thumbnailUrl\n            assetId\n            tagLine\n            currentUserVote\n            upVotes\n            downVotes\n            createdByUser {\n              firstName\n              lastName\n              imageUrl\n            }\n            createdAt\n            permissions\n            isFavourited\n            ", "\n        }\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var ADDITIONAL_FIELDS = "\n  organisationId\n  featuredAt\n  status\n  campaigns {\n    inspirationCampaignId\n    name\n  }\n  updatedByUser {\n    firstName\n    lastName\n    imageUrl\n    jobTitle\n  }\n  createdAt\n  updatedAt\n";

var buildGetInspirationsQuery = function buildGetInspirationsQuery(previewFields) {
  return (0, _graphqlTag.default)(_templateObject(), previewFields ? '' : ADDITIONAL_FIELDS);
};

var getInspirations = function getInspirations() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      previewFields = _ref.previewFields,
      organisationId = _ref.organisationId;

  return {
    query: buildGetInspirationsQuery(previewFields),
    module: 'inspirations',
    ignoreCache: true,
    buildVariables: function buildVariables(variables) {
      return _objectSpread({}, variables, {}, organisationId ? {
        organisationId: organisationId
      } : {});
    }
  };
};

var _default = getInspirations;
exports.default = _default;